import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { AppFooter } from "./AppFooter";
import { useAuth } from "../contexts/AuthContext";
import { useData } from "../contexts/DataContext";

const pageTitles = {
  "/admin": { title: "Dashboard", subtitle: "Live fleet overview and operational intelligence" },
  "/admin/setup-wizard": { title: "Client Setup Wizard", subtitle: "End-to-end onboarding for new transport clients" },
  "/admin/trips": { title: "Trips", subtitle: "Create, assign, and monitor live journeys" },
  "/admin/vehicles": { title: "Vehicles", subtitle: "Track vehicle readiness and assignments" },
  "/admin/incidents": { title: "Incidents", subtitle: "Capture and resolve transport issues" },
  "/admin/users": { title: "Users", subtitle: "Provision users, roles, and password resets" },
  "/admin/schools": { title: "Schools", subtitle: "Manage school profiles and contacts" },
  "/admin/parents": { title: "Parents", subtitle: "Manage parent profiles and linked children" },
  "/admin/reports": { title: "Reports", subtitle: "Council-ready exports, compliance, and handover audit logs" },
  "/admin/notifications": { title: "Notifications", subtitle: "Audit-ready communication log for simulated alerts" },
  "/admin/settings": { title: "Settings", subtitle: "Configure company branding and contact details" },
  "/driver": { title: "Driver Dashboard", subtitle: "Run pre-journey checks and live GPS tracking" },
  "/driver/trips": { title: "My Trips", subtitle: "View and manage your assigned trips" },
  "/driver/incidents": { title: "Driver Incidents", subtitle: "Report issues from the road" },
  "/driver/notifications": { title: "Notifications", subtitle: "Review trip communication and safeguard alerts" },
  "/driver/settings": { title: "Settings", subtitle: "Review your account and platform configuration" },
  "/school": { title: "School Dashboard", subtitle: "Monitor arrivals and live approach status" },
  "/school/trips": { title: "School Trips", subtitle: "Trips linked to your pupils" },
  "/school/incidents": { title: "School Incidents", subtitle: "View and review pupil transport issues" },
  "/school/notifications": { title: "Notifications", subtitle: "Review trip communications and compliance alerts" },
  "/school/settings": { title: "Settings", subtitle: "Review company details and your school profile" },
  "/parent": { title: "Journey Tracking", subtitle: "Live updates for your child’s transport" },
  "/parent/notifications": { title: "Notifications", subtitle: "Review journey notifications and handover updates" },
  "/parent/settings": { title: "Settings", subtitle: "Review account and company information" },
};

export const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const { user } = useAuth();
  const { loadSettings } = useData();

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (user) {
      loadSettings();
    }
  }, [user, loadSettings]);

  const pageInfo = pageTitles[location.pathname] || { title: "Dashboard", subtitle: "CareFleet Transport Ltd" };

  return (
    <div className="app-layout">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <main className="app-main">
        <Header onMenuClick={() => setSidebarOpen(true)} title={pageInfo.title} subtitle={pageInfo.subtitle} />
        <div className="page-content">
          <Outlet />
        </div>
        <AppFooter />
      </main>
    </div>
  );
};

export default Layout;
